import * as React from "react";
const SvgCode24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 18,
        fill: "black",
        viewBox: "0 0 24 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m15.449 1.816.316-.948-1.897-.633-.317.949-5 15-.316.948 1.898.633.316-.949 5-15ZM8.414 3.5l-.707.707L2.914 9l3.793 3.793.707.707L6 14.914l-.707-.707-4.5-4.5L.086 9l.707-.707 5.5-5.5L7 2.086 8.414 3.5Zm8.172 1 .707.707L21.086 9l-4.793 4.793-.707.707L17 15.914l.707-.707 5.5-5.5.707-.707-.707-.707-4.5-4.5L18 3.086 16.586 4.5Z",
      clipRule: "evenodd"
    })
  );
export default SvgCode24Px;
